export const allRoutes: Record<string, any> = {
  seriesHome: (id: string) => `/${id}`,
  seriesFixtures: (id: string) => `${id}fixtures`,
  seriesStandings: (id: string) => `${id}points-table`,
  seriesStats: (id: string) => `${id}stats`,
  seriesTeams: (id: string) => `${id}teams`,
  seriesSquads: (id: string) => `${id}squads`,
  seriesArchives: (id: string) => `${id}archives`,
  seriesHomeAsFixtures: (id: string) => `/${id}`,
  cricketSeries: '/series',
  liveScore: '/live-cricket-score',
  cricketSeriesArchive: '/cricket-series-archive',
  matchDetail: (slug: string) => `/${slug}`,
  matchDetailScorecard: (slug: string) => `${slug}full-scorecard`,
  matchDetailCommentary: (slug: string) => `/${slug}commentary`,
  matchDetailStandings: (slug: string) => `${slug}points-table`,
  matchDetailUpcoming: (slug: string) => `${slug}fixtures-and-results`,
  matchDetailResult: (slug: string) => `${slug}results`,
  matchDetailFantasyTips: (slug: string) => `${slug}fantasy-tips`,
  matchDetailOvers: (slug: string) => `${slug}overs`,
  matchDetailLiveStats: (slug: string) => `${slug}live-stats`,
  home: '/',
  iccRankings: '/icc-rankings',
  teams: '/teams',
  players: '/players',
  cricketSeriesPages: 'series',
  termsAndConditions: '/terms-of-use',
  copyrightsNotice: '/copyright-notice',
  writeForUs: '/write-for-us',
  privacyPolicy: '/privacy-policy',
  disclaimer: '/disclaimer',
  dmca: '/dmca',
  aboutUs: '/about-us',
  contactUs: '/contact-us',
  gdprCompilance: '/gdpr-compilance',
  affiliate: '/affiliate',
  feedback: '/feedback',
  cricketNews: '/cricket-news',
  hindiNews: '/cricket-hindi-news',
  authorDetail: (slug: string) => `/author/${slug}`
}

export const matchDetailTabSlug = [
  'full-scorecard',
  'news',
  'fixtures-and-results',
  'fantasy-tips',
  'overs',
  'points-table',
  'commentary',
  'live-stats',
  'live-blog'
]
export const cricketSeriesSlug = [
  'standings',
  'stats',
  'teams',
  'squads',
  'fantasy-tips',
  'fixtures'
]
